import {
  SUBMIT,
  UPDATE_NAME,
  UPDATE_ACTIVE,
  UPDATE_FILE_ID,
  MOUNT,
  UNMOUNT,
} from './constants'

const submit = () => ({ type: SUBMIT })
const updateActive = (active) => ({ type: UPDATE_ACTIVE, active })
const updateFileId = (id) => ({ type: UPDATE_FILE_ID, id })
const updateName = (value) => ({ type: UPDATE_NAME, value })
const mount = (id) => ({ type: MOUNT, id })
const unmount = () => ({ type: UNMOUNT })

export {
  updateActive,
  updateFileId,
  updateName,
  mount,
  unmount,
  submit,
}
